import { gql } from 'graphql-request';

export type ThreatenedSpecies = {
    scientificName: string;
    commonName: string | null;
    /** IUCN category code — CR, EN or VU (the threatened set for this list). */
    iucnCategory: string;
    /** Prediction confidence: `high`, `medium` or `low`. */
    confidence: string;
};

// `siteThreatenedSpecies` is a top-level engine query (not nested under `site`).
// Paginated (most-threatened first) via the engine's standard page/pageSize
// contract — the widget asks for a small page and reads `pagination.totalItems`
// for its count; the modal asks for a large page to show the full list.
export type IucnCategoryCount = {
    /** IUCN category code — CR, EN, VU or NT (LC is not returned). */
    category: string;
    count: number;
};

export type IucnSummary = {
    /** CR + EN + VU — strict IUCN "threatened". */
    threatenedCount: number;
    /** All categories in the breakdown (CR + EN + VU + NT). */
    totalCount: number;
    /** Per-category counts, most-threatened first. */
    categories: IucnCategoryCount[];
};

export const siteThreatenedSpeciesQuery = gql`
    query SiteThreatenedSpecies($organisationBusinessCentralId: String!, $siteId: ID!, $page: Int!, $pageSize: Int!) {
        siteThreatenedSpecies(
            organisationBusinessCentralId: $organisationBusinessCentralId
            siteId: $siteId
            page: $page
            pageSize: $pageSize
        ) {
            snapshot
            species {
                items {
                    scientificName
                    commonName
                    iucnCategory
                    confidence
                }
                pagination {
                    totalItems
                }
            }
            summary {
                threatenedCount
                totalCount
                categories {
                    category
                    count
                }
            }
        }
    }
`;

export type SiteThreatenedSpeciesResult = {
    siteThreatenedSpecies: {
        /** Grid snapshot the list was read from (provenance). */
        snapshot: string;
        species: {
            items: ThreatenedSpecies[];
            pagination: {
                /** Full Red List count for the site, regardless of page size. */
                totalItems: number;
            };
        };
        summary: IucnSummary;
    } | null;
};
